`<template>
  <person
    :model="model"
    :disabled="disabled"
    :hide-error="hideError"
    :has-address="hasAddress"
    :address-title="addressTitle"
  >
    <div class="row">
      <w-input
        class="col form-group"
        :model="peselSchema"
        :disabled="checkDisabled('pesel')"
        :show-error="checkHiddenError('pesel')"
        :trim="true"
      />

      <w-datepicker
        v-if="model.birthDate"
        class="col form-group"
        :model="model.birthDate"
        :disabled="checkDisabled('birthDate')"
        :show-error="checkHiddenError('birthDate')"
      />

      <slot name="innerData" />
    </div>

    <slot />
  </person>
</template>

<script>
import { componentMixin } from '@/mixins/document/component';
import Person from './Person';

// @vuese
// Komponent osoby
// @Group formComponents
export default {
  components: { Person },
  mixins: [componentMixin],
  props: {
    // Alternatywny tytuł adresu
    addressTitle: { type: String, required: false },

    // Czy wyświetlić adres
    hasAddress: { type: Boolean, default: true },

    // Alternatywny model peselu
    peselModel: { type: Object, required: false }
  },
  computed: {
    peselSchema() {
      return this.peselModel || this.model.pesel;
    }
  }
};
</script>
